// @flow

import * as React from 'react';
import ReactAI from 'react-appinsights';

type Props = {
    text: string,
    onClick: Function,
};

const AddButton = (props: Props) => {
    return <div className="add-button print-hide" onClick={props.onClick}>
        <div className="plus">
            <i className="fas fa-plus fa-thin fa-xl"></i>
        </div>
        <div className="text">{props.text}</div>
    </div>
};

export default ReactAI.withTracking(AddButton);




// WEBPACK FOOTER //
// ./src/components/AddButton.js